import React from "react";
import { KgInspectorNavLinkRow } from "../../atoms/KgInspectorNavLinkRow";
import { kgInspectorIcons } from "../../kg/canvas/inspector/kgInspectorIcons";
import type { KgInspectorIconKey } from "../../kg/canvas/inspector/kgInspectorIcons";
import {
  CountBadge,
  EmptyHint,
  EmptyTabBody,
  IconSlot,
  LinkRowStack,
  RuleSection,
  SectionHeader,
  SectionTitle,
  TabRoot,
} from "./KgInspectorRulesTab.styles";
import type { KgInspectorRulesTabProps } from "./KgInspectorRulesTab.types";

const DEFAULT_EMPTY_HINT = "No rules linked to this ontology yet.";

const sectionIcon = (iconKey: KgInspectorIconKey) => {
  const Icon = kgInspectorIcons[iconKey];
  return <Icon size={16} />;
};

const sectionsWithItems = (
  sections: KgInspectorRulesTabProps["sections"],
) => sections.filter((section) => section.items.length > 0);

export const KgInspectorRulesTab: React.FC<KgInspectorRulesTabProps> = ({
  sections,
  emptyHint = DEFAULT_EMPTY_HINT,
}) => {
  const populatedSections = sectionsWithItems(sections);

  if (populatedSections.length === 0) {
    return (
      <TabRoot>
        <EmptyTabBody>
          <EmptyHint>{emptyHint}</EmptyHint>
        </EmptyTabBody>
      </TabRoot>
    );
  }

  return (
    <TabRoot>
      {populatedSections.map((section) => (
        <RuleSection key={section.id}>
          <SectionHeader>
            <IconSlot>{sectionIcon(section.iconKey)}</IconSlot>
            <SectionTitle>{section.label}</SectionTitle>
            <CountBadge>{section.items.length}</CountBadge>
          </SectionHeader>
          <LinkRowStack>
            {section.items.map((item) => (
              <KgInspectorNavLinkRow key={item.label} link={item} />
            ))}
          </LinkRowStack>
        </RuleSection>
      ))}
    </TabRoot>
  );
};

export default KgInspectorRulesTab;
